import { render, staticRenderFns } from "./Adm_perfil.vue?vue&type=template&id=14468de0&scoped=true"
import script from "./Adm_perfil.vue?vue&type=script&lang=js"
export * from "./Adm_perfil.vue?vue&type=script&lang=js"
import style0 from "./Adm_perfil.vue?vue&type=style&index=0&id=14468de0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14468de0",
  null
  
)

export default component.exports